import * as sagaEffects from 'redux-saga/effects';
import { getFirestore } from 'redux-firestore';
import { getFirebase } from 'react-redux-firebase';

import { arrayMoveImmutable as arrayMove } from 'array-move';
import { getIntl } from '@ackee/jerome/antd';
import message from 'antd/lib/message';

import config from 'config/index';
import * as loglevel from 'config/loglevel';

import { imageMapsRequest } from '../actions';
import { selectImageMaps } from '../selectors';
import types from '../actionTypes';

const { takeEvery, put, select } = sagaEffects;

function* handler({ meta }) {
    const firestore = getFirestore(getFirebase());
    const intl = yield getIntl();

    const imageMaps = yield select(selectImageMaps);
    const orderedInfo = arrayMove(imageMaps, meta.oldIndex, meta.newIndex);

    const batch = firestore.batch();

    try {
        for (const lang of config.app.languages) {
            for (let index = 0; index < orderedInfo.length; index += 1) {
                if (orderedInfo[index]) {
                    const { id } = orderedInfo[index];
                    const ref = yield firestore.doc(`languages/${lang}/imageMaps/${id}`);
                    batch.update(ref, { order: index });
                }
            }
        }
        yield batch.commit();
        yield put(imageMapsRequest({ silent: true }));
    } catch (e) {
        loglevel.error(e);
        message.error(intl.formatMessage({ id: 'errors.maps.image.order' }));
    }
}
export default function* () {
    yield takeEvery(types.UPDATE_IMAGE_MAP_ORDER, handler);
}
